const en = {
    'permissiongroup.table.button.create': 'Create permission group',
    'permissiongroup.table.filter_by_sku': 'Filter by SKU',
    'permissiongroup.table.filter_by_description': 'Filter by Description',
    'permissiongroup.table.filter_by_deleted': 'Filter by Deleted',
    'permissiongroup.table.filter_by_deleted_deleted': 'Deleted',
    'permissiongroup.table.filter_by_deleted_not_deleted': 'Not Deleted',
    'permissiongroup.table.filter_by_deleted_all': 'All',
    'permissiongroup.table.title': 'Permission Group',
    'permissiongroup.table.sku': 'SKU',
    'permissiongroup.table.description': 'Description',
    'permissiongroup.table.actions': 'Actions',
    'permissiongroup.table.modal.delete.title': 'Delete',
    'permissiongroup.table.modal.delete.done': 'Success',
    'permissiongroup.table.modal.delete.phrase': 'Are you sure you want to delete?',
    'permissiongroup.table.modal.delete.button.cancel': 'Cancel',
    'permissiongroup.table.modal.delete.button.delete': 'Delete',
    'permissiongroup.table.modal.restore.title': 'Restore',
    'permissiongroup.table.modal.restore.done': 'Success',
    'permissiongroup.table.modal.restore.phrase': 'Are you sure you want to restore?',
    'permissiongroup.table.modal.restore.button.cancel': 'Cancel',
    'permissiongroup.table.modal.restore.button.restore': 'Restore',

    'permissiongroup.form.permissions_not_found': 'Permissions not found',
    'permissiongroup.form.permissions': 'Permissions',
    'permissiongroup.form.update': 'Update group',
    'permissiongroup.form.create': 'Create group',
    'permissiongroup.form.sku': 'SKU',
    'permissiongroup.form.description': 'Description',
    'permissiongroup.form.cancel': 'Back',
};

export default en;